module.exports = __webpack_public_path__ + "img/cross1yellow.0b7bb259.png";